import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

import { FapRestBaseService } from '../../../base/fap-rest-base.service';
import { ResponseModel } from '../../../models/response.model';
import { FapAPIRequestOptions } from '../fap-api-request.options';

@Injectable()
export class EntityService extends FapRestBaseService {
    constructor(tosterService: ToastrService,
                private _http: HttpClient) {
        super(tosterService, _http, '/entity/');
    }

    getUrl(slug) {
        return this.url+slug
    }

    public getEntities(params?): Observable<ResponseModel<{}>> {
        return this.mapRequest<any[]>(
            this._http.get(this.url + 'adv_data/', {
                headers: FapAPIRequestOptions.withTokenHeaders,
                params
            }),false,
            false
        ).pipe(take(1));
    }

    public getEntitiesColumns(params?): Observable<ResponseModel<{}>> {
        return this.mapRequest<any[]>(
            this._http.get(this.url + 'adv_data/profile/', {
                headers: FapAPIRequestOptions.withTokenHeaders,
                params
            }),false,
            false
        ).pipe(take(1));
    }

    public getProfiles(params?): Observable<ResponseModel<{}>> {
        return this.mapRequest<any[]>(
            this._http.get(this.url + 'profiles/', {
                headers: FapAPIRequestOptions.withTokenHeaders,
                params
            }),false,
            false
        ).pipe(take(1));
    }

    public updateProfile(sensorGroupId: number, sensorGroup:{}, type: string): Observable<ResponseModel<any[]>> {
        return this.mapRequest<any>(
            this.http.patch(this.url + 'profiles/' + sensorGroupId + '/',
                this.camelCaseModelToSnakeCaseJson(sensorGroup),
                FapAPIRequestOptions.withTokenRequestOptions),
            false,
            false
        ).pipe(take(1));
    }

    public addProfile(data, type: string): Observable<ResponseModel<any>> {
        return this.mapRequest<any>(
            this._http.post(this.url + 'profiles/', data,
                FapAPIRequestOptions.withTokenRequestOptions),
                false,
            false
        ).pipe(take(1));
    }

    public deleteProfile(profileId: number): Observable<ResponseModel<any>> {
        return this.mapRequest<any>(
            this.http.delete(this.url + 'profiles/' + profileId + '/',
                FapAPIRequestOptions.withTokenRequestOptions,
            ),
            false
            ).pipe(take(1));
    }

    public postColumns(params: any, sensorGroupTypeId): Observable<ResponseModel<{}>> {
        return this.mapRequest(
          this._http.put(this.url + "adv_data/profile/?&id="+sensorGroupTypeId,
              params,
              FapAPIRequestOptions.withTokenRequestOptions),
              false,
              true
      ).pipe(take(1));
    }

    public getEntityFields(params: any): Observable<ResponseModel<{}>> {
        return this.mapRequest<any[]>(
            this._http.get(this.url + 'adv_data/fields/', {
                headers: FapAPIRequestOptions.withTokenHeaders,
                params
            }),false,
            false
        )
    }
   
}